var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgType5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 56,
    viewBox: "0 0 68 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10110_37767)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 56,
    rx: 6,
    fill: "#F3F7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 56,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.898,
    height: 1,
    transform: "matrix(1 0 0 -1 10 25)",
    fill: "#EEF6FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 1,
    transform: "matrix(1 0 0 -1 10 32)",
    fill: "#EEF6FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10110_37767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 56,
    rx: 6,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType5);
export default __webpack_public_path__ + "static/media/type_5.3bfd7b211f835fb171ba9352c1dd2bcd.svg";
export { ForwardRef as ReactComponent };